<div class="card">
  <!-- Heading -->
  <div class="card-header compact">
    <h1>
      <span>{{ 'infoEdit.header' | translate }}</span>
      <fw-action-menu *ngIf="displayActionMenu && (file || container)" [auditable]="file || container" [fieldLabel]="'infoEdit.actionMenuLabel' | translate" fieldKey="info" (click)="$event.stopPropagation()"></fw-action-menu>
    </h1>
    <div class="card-actions">
      <app-button-group *ngIf="writable" (click)="$event.stopPropagation()" class="small fill-white">
        <button type="button"
          mat-stroked-button
          data-id="custom-information-add"
          [matMenuTriggerFor]="addMenu">
          <mat-icon class="xs" iconPositionEnd>add</mat-icon>
        </button>
        <button *ngIf="displaySave"
          type="button"
          mat-flat-button
          color="accent"
          data-id="custom-information-save"
          (click)="saveFields()"
          [matTooltip]="infoForm.invalid ? ('infoEdit.invalidTooltip' | translate) : null"
          [ngClass]="{'disabled': infoForm.invalid}">
          {{ 'common.actions.save' | translate }}
        </button>
        <button type="button"
          mat-stroked-button
          data-id="custom-information-cancel"
          (click)="resetFields()">
          {{ 'common.actions.reset' | translate }}
        </button>
        <mat-menu #addMenu="matMenu">
          <div [attr.data-id]="'custom-information-dropdown'">
            <button class="small" mat-menu-item (click)="addField('string')">
              <mat-icon class="info-icon">text_fields</mat-icon> {{ 'infoEdit.fieldTypes.string' | translate }}
            </button>
            <button class="small" mat-menu-item (click)="addField('boolean')">
              <mat-icon class="info-icon">toggle_on</mat-icon> {{ 'infoEdit.fieldTypes.boolean' | translate }}
            </button>
            <button class="small" mat-menu-item (click)="addField('number')">
              <mat-icon class="info-icon">123</mat-icon> {{ 'infoEdit.fieldTypes.number' | translate }}
            </button>
            <button class="small" mat-menu-item (click)="addField('array')">
              <mat-icon class="info-icon">list</mat-icon> {{ 'infoEdit.fieldTypes.array' | translate }}
            </button>
            <button class="small" mat-menu-item (click)="addField('object')">
              <mat-icon class="info-icon">data_object</mat-icon> {{ 'infoEdit.fieldTypes.object' | translate }}
            </button>
          </div>
        </mat-menu>
      </app-button-group>
    </div>
  </div>
  <info-property
    [field]="infoForm"
    [index]="0"
    [writable]="writable"
    [class]="{ hidden: empty, properties: true }">
  </info-property>
  <div *ngIf="empty" class="blank-state">
    <mat-icon class="sm raised blue">list</mat-icon>
    <p>{{ 'infoEdit.emptyMessage' | translate }}</p>
  </div>
</div>
